import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { api } from '../api'


type HealthResp = {
  is_healthy: boolean
  reasons: string[]
}


/** Red banner shown at the top of every Studio page when workspace sync
 *  is unhealthy. Fetches every 30s. Silent when healthy — so it only
 *  appears when something needs attention. Not shown on non-Studio
 *  pages (Workspace stays clean per Emerson's preference). */
export default function SyncHealthBanner() {
  const q = useQuery({
    queryKey: ['syncHealthBanner'],
    queryFn: async () => (await api.get<HealthResp>('/sync/health/')).data,
    refetchInterval: 30_000,
    // Failing the endpoint is not itself a banner-worthy event (permission
    // check, backend restart, etc.) — silent.
    retry: false,
  })
  if (!q.data || q.data.is_healthy) return null
  const primary = q.data.reasons[0] || 'Workspace sync is unhealthy — see Sync tab for details.'
  const extra = q.data.reasons.length > 1 ? ` (+${q.data.reasons.length - 1} more)` : ''
  return (
    <div className="flex items-center gap-3 border-b border-red-600 bg-red-600 px-3 py-1.5 text-[12px] text-white">
      <span className="font-semibold">⚠ Sync unhealthy:</span>
      <span>{primary}{extra}</span>
      <Link to="/studio/sync" className="ml-auto underline">Sync tab →</Link>
    </div>
  )
}
